/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 23-10-2020.
 */
import React from 'react'
import Spinner from './Spinner'

type Props = {
  children?: React.ReactNode
  minHeight?: number
  size?: number
  marginBottom?: number
}

export const SpinnerFullHeight: React.FC<Props> = ({
  children = null,
  minHeight = 300,
  marginBottom = 30,
  size = 10,
}) => {
  return (
    <div className={`container-fluid px-0 my-5 h-100`} style={{ minHeight: minHeight }}>
      <div className="row h-100">
        <div className="col-12 d-flex justify-content-center align-items-center">
          <div className="d-flex align-items-center flex-column">
            <Spinner style={{ marginBottom: marginBottom }} size={size} />
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
